import { Injectable } from '@angular/core';
import * as _ from 'lodash';

const CONTEXT_LINES = 5;

@Injectable()
export class DiffContextService {

  getContextLines(diff: any, idx: number): any[] {
    const size = CONTEXT_LINES; // How many lines we actually grab

    if (!Array.isArray(diff?.lines)) {
      return [];
    }

    // If we're too near the beginning, just give the first five lines
    let lines = [];

    if (idx < size) {
      lines = diff.lines.slice(0, size);
    } else {
      lines = diff.lines.slice(idx - (size - 1), idx + 1);
    }

    const ret = _.map(lines, _.partialRight(_.pick, ['type', 'new', 'old', 'line']));

    return ret;
  }

  shouldShowContext(diff: any, idx: number, comment: any): boolean {
    if (!diff) {
      return true;
    }

    if (idx < 0) {
      return true;
    }

    const a = comment.context;
    const b = this.getContextLines(diff, idx);

    const d = _.differenceWith(
      a,
      b,
      (a, b) =>
        a['line'] === b['line'] &&
        a['new'] === b['new'] &&
        a['old'] === b['old'] &&
        a['type'] === b['type']
    );

    return _.size(d) > 0;
  }

  getCommitLine(line: any): boolean | number {
    if (!line) {
      return false;
    }

    if (line.type === 'old') {
      return line.old;
    }

    return line.new;
  }
}
